import { AbstractPlayer } from './abstract-player'

/**
 * SendToNews video player.
 * Just for assigning element to the Store
 */
export class SendToNews extends AbstractPlayer {
    public constructor(protected element: HTMLElement) {
        super(element)
        this.iframeData = JSON.parse(this.element.dataset.evtVal || '{}')
    }
    /* eslint-disable @typescript-eslint/no-unused-vars */
    setMute(_: boolean) {
        return
    }
    setControls(_: boolean) {
        return
    }
    setLoop(_: boolean) {
        return
    }
    setAutoplay(_: boolean) {
        return
    }
    async init() {
        return
    }
    get title() {
        return ''
    }
    get index() {
        return 0
    }
    pause() {
        return
    }
    play() {
        return
    }
    playVideoAt(_: number) {
        return
    }
    destroy() {
        return
    }
    cuePlaylist(_: YT.IPlaylistSettings) {
        return
    }
    getState() {
        return ''
    }
    isPausable() {
        return true
    }
    onError(_: YT.OnErrorEvent | jwplayer.ErrorParam) {
        return
    }
    render() {
        // create a script element
        const script = document.createElement('script')
        const cid = this.element.dataset.stnCid
        const fk = this.element.dataset.stnFk
        const stnFloat = this.element.dataset.stnFloat
        script.setAttribute('type', 'text/javascript')
        script.setAttribute('async', '')
        script.setAttribute('data-type', 'text/javascript')
        script.setAttribute(
            'src',
            `//embed.sendtonews.com/player2/embedcode.php?fk=${fk}&cid=${cid}${stnFloat}`
        )
        if (this.element) {
            this.element.insertAdjacentElement('afterend', script)
        }
        return
    }
}
